/** Visual marker only; the owning control must expose its required semantics. */
export function RequiredMark() {
  return (
    <span aria-hidden="true" className="text-destructive">
      {' '}
      *
    </span>
  );
}
